import { render } from "./ModalConfirmDeleteInvite.vue?vue&type=template&id=4436052d&scoped=true"
import script from "./ModalConfirmDeleteInvite.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDeleteInvite.vue?vue&type=script&lang=js"

import "./ModalConfirmDeleteInvite.vue?vue&type=style&index=0&id=4436052d&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4436052d"]])

export default __exports__